import { Typography } from "./../../../util";
import { isMittiBrand } from "../../../../config/brand";
import * as Styled from "./styles.css";

const CARE_FOOTER_DISCLOSURE =
  "Insurance products are issued by SafetyCulture Care Australia Pty Ltd " +
  "ABN 54 662 653 303 AFSL 544306 (SafetyCulture Care) as agent for the " +
  "insurer Allianz Australia Insurance Limited ABN 15 000 122 850 AFS " +
  "Licence No 234708 (Allianz). SafetyCulture Care has a binding authority " +
  "to issue, renew, vary and cancel contracts of insurance and to handle " +
  "and settle claims on behalf of Allianz.";

const MITTI_FOOTER_DISCLOSURE =
  "Insurance products are issued by Mitti Insurance Pty Ltd (formerly known " +
  "as SafetyCulture Care Australia Pty Ltd) ABN 54 662 653 303 AFSL 544306 " +
  "(Mitti Insurance) as agent for participating insurers (the Insurers), as " +
  "specified in Your policy documentation. Mitti Insurance is an " +
  "underwriting agency that specialises in insurance products and risk " +
  "solutions. Mitti Insurance has a binding authority to issue, renew, vary " +
  "and cancel contracts of insurance and to handle and settle claims on " +
  "behalf of the Insurers. Neither We nor the underwriting Insurer provide " +
  "any advice on this insurance based on any consideration of Your " +
  "objectives, financial situation or needs. Policy terms, conditions, " +
  "Limits, exclusions and underwriting criteria apply.";

const Footer = () => {
  return (
    <Styled.AppFooter>
      <Typography variant="body2">
        {isMittiBrand ? MITTI_FOOTER_DISCLOSURE : CARE_FOOTER_DISCLOSURE}
      </Typography>

      {process.env.REACT_APP_VERSION && (
        <Styled.Version>
          release: {process.env.REACT_APP_VERSION}
        </Styled.Version>
      )}
    </Styled.AppFooter>
  );
};
export default Footer;
